export const CORRELATIONS_PATH = '/v4/alerting/correlations';

export const correlationPath = (id: string) => `${CORRELATIONS_PATH}/${id}`;

/** A correlation's page, remembering the list it was opened from, with its filters, for the page's breadcrumb. */
export const correlationLocation =
  (id: string) =>
  ({ pathname, search }: { pathname: string; search: string }) => ({
    pathname: correlationPath(id),
    state: { from: `${pathname}${search}` }
  });
